export const uiText = {
  title: "Invitar personas a iniciativa",
  sendedInvitationsTitle: "Invitaciones a la iniciativa enviadas",
  loading: "Cargando...",
  save: "Enviar",
  success: "¡Invitación enviada con éxito!",

  restartForm: "Reiniciar el formulario",
  error: {
    noUpdateData:
      "No se ha podido procesar la solicitud. Por favor intenta de nuevo.",
    actionError:
      "Ocurrió un problema al realizar la acción, vuelve a cargarla página.",
    noGetData:
      "No es posible obtener los detalles de las iniciativas, intenta de nuevo más tarde",
  },

  criticalError: {
    user: "Error interno de la app",
    log: "Critical error:",
  },

  form: {
    emailsLabel: "Correos electrónicos de los invitados (separados por coma)",
    messageLabel: "Mensaje personalizado (opcional)",

    validation: {
      emailsRequired: "Debes ingresar al menos un correo electrónico válido.",
      badEmailFormat: "Los correos no tienen un formato válido",
    },
  },
};
